export default {"src":"/_next/static/media/patio.35dcdff9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};